import { useEffect } from "react";
import imgA from "../../../../Assets/infinit_iot.png";
import imgB from "../../../../Assets/inovation.png";
import imgC from "../../../../Assets/server.png";
import * as S from "./styles";

const BLOCKS = [
  {
    title: "Eficiência Operacional",
    text:
      "Tornamos processos mais inteligentes e fluidos para que sua empresa economize tempo, reduza custos e mantenha a engrenagem sempre girando.",
    bullets: [
      { title: "DevOps & DevSecOps", text: "Ciclos ágeis, seguros e escaláveis." },
      { title: "Integrações & Infra", text: "Conectamos legados e plataformas modernas." },
      { title: "IoT e Gestão de Energia", text: "Controle total em ambientes complexos." },
    ],
    img: imgA,
  },
  {
    title: "Inovação e Vantagem Competitiva",
    text:
      "De ideias a produtos digitais: aplicamos design, tecnologia e métodos ágeis para criar soluções que colocam você à frente do mercado.",
    bullets: [
      {
        title: "Squads e outsourcing sob medida",
        text: "Times dedicados que aceleram cada etapa do projeto com foco e especialização.",
      },
      {
        title: "Back-end e firmware robustos",
        text: "Arquiteturas sólidas que garantem performance, escalabilidade e segurança.",
      },
      {
        title: "Design System e UX consistentes",
        text:
          "Interfaces intuitivas e padronizadas que fortalecem a identidade e elevam a experiência do usuário.",
      },
    ],
    img: imgB,
  },
  {
    title: "Gestão e inteligência de dados",
    text:
      "Transformamos dados em inteligência. De pipelines a dashboards, criamos arquiteturas seguras e análises que orientam decisões.",
    bullets: [
      {
        title: "Big Data e Analytics de ponta a ponta",
        text:
          "Pipelines completos que coletam, tratam e transformam grandes volumes de dados em insights práticos para o negócio.",
      },
      {
        title: "Qualidade, Testes & Performance",
        text:
          "Processos rigorosos que asseguram precisão, velocidade e confiabilidade em cada solução entregue.",
      },
    ],
    img: imgC,
  },
];

const ROW1 = [
  "Design UI/UX",
  "BackEnd",
  "APIs",
  "Banco de Dados",
  "FrontEnd",
  "Kubernetes",
  "CI/CD",
  "QA"
];

const ROW2 = [
  "Banco de Dados",
  "APIs",
  "Front",
  "Design UI/UX",
  "React",
  "Docker",
  "Node",
  "GraphQL"
];

export const ValueSection = () => {

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const rows = document.querySelectorAll('[data-row]');
    const io = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    rows.forEach(r => io.observe(r));
    return () => io.disconnect();
  }, []);

  return (
    <S.Wrapper>
      <S.SectionHead>
        <h2>
          Como criamos valor na prática
        </h2>
      </S.SectionHead>

      {/* Mobile: lista vertical */}
      <S.MobileList>
        {BLOCKS.map((b, i) => (
          <S.MobileCard key={i}>
            <h3>{b.title}</h3>
            <p>{b.text}</p>
            <ul>
              {b.bullets.map((t, k) => (
                <li key={k}>
                  <span className="dot" />
                  <div className="li-content">
                    <strong>{t.title}</strong>
                    <span className="sub">{t.text}</span>
                  </div>
                </li>
              ))}
            </ul>
          </S.MobileCard>
        ))}
      </S.MobileList>

      {/* Desktop: imagem + texto alternando lados */}
      <S.TopShadow aria-hidden />

      <S.DesktopGrid>
        {BLOCKS.map((b, i) => (
          <S.Row key={i} $reverse={i % 2 === 1} data-row>
            <img src={b.img} alt={b.title} />

            <S.MobileCard key={i} className="texts">
              <h3>{b.title}</h3>
              <p>{b.text}</p>
              <ul>
                {b.bullets.map((t, k) => (
                  <li key={k}>
                    <span className="dot" />
                    <div className="li-content">
                      <strong>{t.title}</strong>
                      <span className="sub">{t.text}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </S.MobileCard>
          </S.Row>
        ))}
      </S.DesktopGrid>

      <S.Marquee>
        {/* Linha 1 -> move para a esquerda */}
        <S.MarqueeRow>
          <S.Track className="left">
            {[...ROW1, ...ROW1].map((t, i) => (
              <S.Chip key={`r1-${i}`}>{t}</S.Chip>
            ))}
          </S.Track>
        </S.MarqueeRow>

        {/* Linha 2 -> move para a direita */}
        <S.MarqueeRow>
          <S.Track className="right">
            {[...ROW2, ...ROW2].map((t, i) => (
              <S.Chip key={`r2-${i}`}>{t}</S.Chip>
            ))}
          </S.Track>
        </S.MarqueeRow>
      </S.Marquee>
    </S.Wrapper>
  );
};
